import { INavData } from '@coreui/angular-pro';

export function getNavItems(): INavData[] {
  const userInfo = localStorage.getItem('UserInfo') || '{}';
  let parsedUserInfo: any = {};
  try {
    parsedUserInfo = JSON.parse(userInfo);
  } catch {
    parsedUserInfo = {};
  }
  const roleId = Number(parsedUserInfo.effectiveRoleId || parsedUserInfo.role_id || 0);
  const permissionCache = localStorage.getItem('UserPermissions');
  const hasLoadedPermissions = permissionCache !== null;
  let permissions: string[] = [];
  try {
    permissions = JSON.parse(permissionCache || '[]');
  } catch {
    permissions = [];
  }
  const hasPermission = (permissionKey?: string | string[]) => {
    if (!permissionKey) return true;
    if (roleId === 1) return true;
    if (!hasLoadedPermissions) return false;
    if (Array.isArray(permissionKey)) {
      return permissionKey.some((permission) => permissions.includes(permission));
    }
    return permissions.includes(permissionKey);
  };

  const leaf = (
    name: string,
    url: string,
    iconName: string,
    permissionKey: string | string[]
  ) => ({
    name,
    url,
    iconComponent: { name: iconName },
    permissionKey
  });

  const visibleLeaf = (item: any) => hasPermission(item.permissionKey);

  const group = (name: string, iconName: string, children: any[]) => {
    const visibleChildren = children.filter(visibleLeaf).map(({ permissionKey, ...item }) => item);
    if (!visibleChildren.length) return null;
    return {
      name,
      iconComponent: { name: iconName },
      children: visibleChildren
    };
  };

  const allNavItems: any[] = [
    {
      name: 'Dashboard',
      url: '/dashboard',
      iconComponent: { name: 'cil-speedometer' },
      permissionKey: 'dashboard.view',
      
    },
    group('Accounts Management', 'cil-people', [
      leaf('Users', '/Settings/Users', 'cil-user', 'users.view'),
      leaf('Customers', '/Settings/Customers', 'cil-user', 'customers.view'),
      leaf('Partners', '/Settings/Partners', 'cil-user', 'partners.view'),
      leaf('Partner Levels', '/Settings/PartnerLevels', 'cil-layers', 'partner_levels.manage'),
      leaf('BDRs', '/Settings/BDRs', 'cil-people', 'bdrs.view')
    ]),
    group('Orders', 'cil-spreadsheet', [
      leaf('All Orders', '/Settings/Orders', 'cil-spreadsheet', 'orders.view'),
      leaf('On Hold Orders', '/Settings/ArchiveOrders', 'cil-spreadsheet', 'on_hold_orders.view')
    ]),
    group('Tasks', 'cil-task', [
      leaf('Assigned Tasks', '/Settings/Tasks', 'cil-task', 'assigned_tasks.view')
    ]),
    group('Configuration', 'cil-settings', [
      leaf('Sales Agent Tasks', '/Settings/SalesAgentTasks', 'cil-task', 'sales_tasks.manage'),
      leaf('Coordinator Tasks', '/Settings/CoordinatorTasks', 'cil-task', 'coordinator_tasks.manage'),
      leaf('Order Page Permissions', '/Settings/OrderPagePermissions', 'cil-lock-locked', 'order_page_permissions.manage'),
      leaf('Order Types', '/Settings/OrderTypes', 'cil-spreadsheet', 'order_types.manage'),
      leaf('Service Types', '/Settings/ServiceTypes', 'cil-settings', 'service_types.manage')
    ]),
    group('Settings', 'cil-settings', [
      leaf('RBAC', '/Settings/RBAC', 'cil-lock-locked', 'rbac.manage'),
      leaf('Commission Policies', '/Settings/CommissionPolicies', 'cil-money', 'commission_policies.view'),
      leaf('SMTP Setup', '/Settings/SMTP', 'cil-envelope-closed', 'smtp.manage'),
      leaf('Email Notifications', '/Settings/EmailNotifications', 'cil-envelope-closed', 'notifications.manage'),
      leaf('Audit Logs', '/Settings/AuditLogs', 'cil-list-rich', 'audit.view')
    ]),
    group('Reports', 'cil-spreadsheet', [
      leaf('Reports', '/Settings/Reports', 'cil-spreadsheet', [
        'reports.view',
        'reports.sales_commission.view',
        'reports.commission.view',
        'reports.sales.view'
      ]),
      leaf('Report Schedules', '/Settings/ReportSchedules', 'cil-calendar', 'reports.schedule')
    ])
  ];

  return allNavItems.filter((item: any) => {
    if (!item) return false;
    if (item['permissionKey']) return hasPermission(item['permissionKey']);
    if (!item['roleIds']) return true;
    return item['roleIds'].includes(roleId);
  });
}
